// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"fed44e8e","239":"97ff08fb","389":"2a069c30","450":"adaa3dff","453":"aa6bf81a","455":"639ff4e1","740":"86fae166","750":"5d216e9f","977":"6911be32"}[chunkId] + ".chunk.js";
};